<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p40"><span><a href="#/Contents#rp40">CELERY AND FENNEL SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Summer living is easy, with this flavorful cold soup ready in the refrigerator.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>3 cups coarsely chopped celery</span></p>
<p class="hang"><span>8 green onions, sliced</span></p>
<p class="hang"><span>1 small garlic clove, minced</span></p>
<p class="hang"><span>1 teaspoon olive oil</span></p>
<p class="hang"><span>1 quart Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>2½ tablespoons uncooked rice</span></p>
<p class="hang"><span>1 teaspoon fennel seeds</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>Fat-free plain yogurt, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Sauté celery, onions, and garlic in oil in large saucepan until onions are tender, about 5 minutes. Add stock, rice, and fennel seeds tied in a cheesecloth bag; heat to boiling. Reduce heat and simmer, covered, until rice is tender, about 20 minutes; discard cheesecloth bag and contents. Process soup in food processor or blender until smooth; season to taste with salt and white pepper. Refrigerate until chilled; garnish each bowl of soup with a dollop of yogurt.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 53</span></p>
<p class="per1"><span>% calories from fat: 15</span></p>
<p class="per1"><span>Protein (g): 4.1</span></p>
<p class="per1"><span>Carbohydrate (g): 7.7</span></p>
<p class="per1"><span>Fat (g): 1.0</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 277</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0222.vue?5ea817f8